import $ from 'jquery';
export default function int_breadcrumb() {
    $(document).ready(function () {
        var item_breadcrumb = $(".breadcrumb-item.second a");
        var id_item = $(".breadcrumb-item.second a").attr('data-id');
        var dropdown = $("#" + id_item + ' .mega-dropdown');
        var mnav_item = $("#" + id_item + ' .mnav-item')
        var width = $(window).width();
        $(window).resize(function() {
            width = $(window).width();
        })
		if ((item_breadcrumb).attr('data-id')){
			 $("#" + (item_breadcrumb).attr('data-id')).addClass("active-default");
		}
        item_breadcrumb.click(function (e) {
            if (dropdown.length){
				e.preventDefault();
				dropdown.addClass('open');
				mnav_item.addClass('open');
              
                if (width <= 768) {
                    $(".main-nav-container").addClass("open");
                    $(".main-nav-container").css({ minHeight: (window.innerHeight - 60) + "px" });
                    $("html").addClass("menu-open");
                    $(".main-nav-wrap .hamburger").addClass('active')
                }
			}
        })
    })
}